import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SITE_CONTENT } from "../content";
import footerLeftLettuce from "../assets/footer_left_lettuce.png";
import footerRightSalad from "../assets/footer_right_salad.png";

const SocialIcon = ({ icon }) => {
  const icons = {
    facebook: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" />
      </svg>
    ),
    twitter: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
      </svg>
    ),
    linkedin: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
      </svg>
    ),
    youtube: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.5 12 3.5 12 3.5s-7.505 0-9.377.55a3.016 3.016 0 0 0-2.122 2.136C0 8.186 0 12 0 12s0 3.814.501 5.814a3.016 3.016 0 0 0 2.122 2.136c1.872.55 9.377.55 9.377.55s7.505 0 9.377-.55a3.016 3.016 0 0 0 2.122-2.136C24 15.814 24 12 24 12s0-3.814-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
      </svg>
    ),
    instagram: (
      <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
      </svg>
    ),
  };
  return icons[icon] || null;
};

const Footer = () => {
  const { global } = SITE_CONTENT;
  const [email, setEmail] = useState("");
  const [agree, setAgree] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email && agree) {
      setSubscribed(true);
      setEmail("");
      setAgree(false);
      setTimeout(() => setSubscribed(false), 5000);
    }
  };

  return (
    <footer className="rest-footer" id="contact">
      {/* Decorative background food graphics */}
      <img src={footerLeftLettuce} alt="" className="footer-decor-left" />
      <img src={footerRightSalad} alt="" className="footer-decor-right" />

      {/* Orange Floating Info Box at the top */}
      <div className="rest-footer-floating-info">
        {/* Item 1: Address */}
        <div className="rest-footer-info-item">
          <div className="info-icon-circle">
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
            </svg>
          </div>
          <div className="info-text">
            <span className="info-label">Address</span>
            <span className="info-value">
              Alagapuram Pudur, Salem & Saibaba Colony, Coimbatore
            </span>
          </div>
        </div>

        {/* Item 2: Send Email */}
        <div className="rest-footer-info-item">
          <div className="info-icon-circle">
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
            </svg>
          </div>
          <div className="info-text">
            <span className="info-label">Send Email</span>
            <span className="info-value">{global.topBar.email}</span>
          </div>
        </div>

        {/* Item 3: Call Us */}
        <div className="rest-footer-info-item">
          <div className="info-icon-circle">
            <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
              <path d="M6.62 10.79a15.06 15.06 0 006.61 6.61l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
            </svg>
          </div>
          <div className="info-text">
            <span className="info-label">Call Us</span>
            <span className="info-value">{global.topBar.phone}</span>
          </div>
        </div>
      </div>

      {/* Main Grid Content */}
      <div className="rest-footer-main-content">
        <div className="rest-footer-grid">
          {/* Column 1: Brand Info */}
          <div className="rest-footer-brand-col">
            {/* Custom Logo branded for FFC */}
            <Link
              to="/"
              className="rest-logo-block"
              style={{ display: "inline-flex", width: "fit-content" }}
            >
              <div className="rest-logo-text-wrap">
                <div className="rest-logo-line-top" />
                <span
                  className="rest-logo-brand"
                  style={{ fontSize: "20px", letterSpacing: "1.5px" }}
                >
                  FLAKES
                </span>
                <div className="rest-logo-line-middle" />
                <span
                  className="rest-logo-subtitle"
                  style={{ fontSize: "7px", letterSpacing: "1.2px" }}
                >
                  FRIED CHICKEN
                </span>
                <div className="rest-logo-line-bottom" />
              </div>
              <div
                className="rest-logo-icon"
                style={{ alignSelf: "center", marginLeft: "8px" }}
              >
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  width="28"
                  height="28"
                >
                  <path d="M12 5V3M10 3h4" />
                  <path d="M4 14a8 8 0 0 1 16 0" />
                  <path d="M2 15h20" />
                  <path d="M16 18c-2 2-3 2-6 2H4a1 1 0 0 1-1-1v-1" />
                  <path d="M19 18a2 2 0 0 0 2-2v-1" />
                </svg>
              </div>
            </Link>

            <p className="brand-description">
              Flakes Fried Chicken (FFC) is a 100% Halal certified premium
              quick-service restaurant brand in Tamil Nadu. We serve signature
              ultra-crispy cornflake-breaded fried chicken, wraps, burgers, and
              flakesfriedchicken meals at honest prices.
            </p>

            <div className="social-links-row">
              {global.footer.socials.map((s, i) => (
                <a
                  key={i}
                  href={s.href}
                  className="social-box"
                  aria-label={s.icon}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <SocialIcon icon={s.icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Column 2: Quick Links */}
          <div className="rest-footer-links-col">
            <h4 className="column-title">
              Quick Links
              <div className="title-underline">
                <span className="underline-orange" />
                <span className="underline-gray" />
              </div>
            </h4>
            <ul className="footer-links-list">
              <li>
                <a href="#about">
                  <span className="arrow-sym">»</span> About Us
                </a>
              </li>
              <li>
                <a href="#menu">
                  <span className="arrow-sym">»</span> Our Gallery
                </a>
              </li>
              <li>
                <a href="#blog">
                  <span className="arrow-sym">»</span> Our Blogs
                </a>
              </li>
              <li>
                <a href="#why">
                  <span className="arrow-sym">»</span> FAQ'S
                </a>
              </li>
              <li>
                <a href="#contact">
                  <span className="arrow-sym">»</span> Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Column 3: Our Menu */}
          <div className="rest-footer-links-col">
            <h4 className="column-title">
              Our Menu
              <div className="title-underline">
                <span className="underline-orange" />
                <span className="underline-gray" />
              </div>
            </h4>
            <ul className="footer-links-list">
              <li>
                <a href="#menu">
                  <span className="arrow-sym">»</span> Crispy Fried Chicken
                </a>
              </li>
              <li>
                <a href="#menu">
                  <span className="arrow-sym">»</span> FFC flakesfriedchicken
                  Meals
                </a>
              </li>
              <li>
                <a href="#menu">
                  <span className="arrow-sym">»</span> Chicken Wraps & Rolls
                </a>
              </li>
              <li>
                <a href="#menu">
                  <span className="arrow-sym">»</span> Tasty Sides & Snacks
                </a>
              </li>
              <li>
                <a href="#menu">
                  <span className="arrow-sym">»</span> Cool Drinks & Desserts
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Contact Us & Newsletter */}
          <div className="rest-footer-contact-col">
            <h4 className="column-title">
              Contact Us
              <div className="title-underline">
                <span className="underline-orange" />
                <span className="underline-gray" />
              </div>
            </h4>

            <div className="opening-hours-row">
              <strong>Monday – Friday:</strong>
              <span className="highlight-orange">11am – 11pm</span>
            </div>
            <div className="opening-hours-row">
              <strong>Saturday – Sunday:</strong>
              <span className="highlight-orange">11am – 11:30pm</span>
            </div>

            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <div className="newsletter-input-container">
                <input
                  type="email"
                  placeholder="Your email address"
                  className="newsletter-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button
                  type="submit"
                  className="newsletter-submit-btn"
                  aria-label="Subscribe"
                >
                  <svg
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    width="16"
                    height="16"
                  >
                    <line x1="5" y1="12" x2="19" y2="12" />
                    <polyline points="12 5 19 12 12 19" />
                  </svg>
                </button>
              </div>

              <label className="privacy-checkbox-label">
                <input
                  type="checkbox"
                  className="privacy-checkbox"
                  checked={agree}
                  onChange={(e) => setAgree(e.target.checked)}
                  required
                />
                <span className="privacy-checkbox-text">
                  I agree to the{" "}
                  <a href="#privacy" className="privacy-link">
                    Privacy Policy
                  </a>
                  .
                </span>
              </label>

              {subscribed && (
                <div
                  style={{
                    color: "#7aff7a",
                    fontSize: "13px",
                    marginTop: "5px",
                    fontWeight: "600",
                  }}
                >
                  ✓ Successfully subscribed to newsletter!
                </div>
              )}
            </form>
          </div>
        </div>
      </div>

      {/* Red Copyright Bar */}
      <div className="rest-footer-copyright-bar">
        <div className="copyright-bar-inner">
          <p className="copyright-text">
            © All Copyright {new Date().getFullYear()} by Flakes Fried Chicken
          </p>
          <div className="copyright-links">
            <a href="#terms" className="copyright-link-box">
              Terms & Condition
            </a>
            <a href="#privacy" className="copyright-link-box">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
